import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/HomePage'

// hack router push callback
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch((err) => err)
}

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'home', component: HomePage },
  { path: '/noticeContent', name: 'noticeContent', component: () => import('@/views/NoticeContent/index.vue') },
  { path: '/infoDetail', name: 'infoDetail', component: () => import('@/views/infoDetail/index.vue') },
  { path: '/purchaseInfo', name: 'purchaseInfo', component: () => import('@/views/PurchaseInfo/index.vue') },
  { path: '/helpCenter', name: 'helpCenter', component: () => import('@/views/HelpCenter/index.vue') },
  { path: '/policy', name: 'policy', component: () => import('@/views/Policy/index.vue') },
  { path: '/policyContent', name: 'policyContent', component: () => import('@/views/PolicyContent/index.vue') },
  { path: '/companyInfo', name: 'companyInfo', component: () => import('@/views/CompanyInfo/index.vue') },
  { path: '/communication', name: 'communication', component: () => import('@/views/Communication/index.vue') },
  { path: '*', redirect: '/' },
]

export default routes
